/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager";

export class Camel extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const camel = new CustomAnimatedSprite(0,0, resources, R.spines.camel)
    // const camelWalking = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelWalking)
    // const camelFrighten = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelFrighten)
    // const camelProtagonist = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelProtagonist)
    // const camelCarryWalk = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelCarryWalk)
    // const camelCarryWink = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelCarryWink)

    this.camel = camel
    // this.camelWalking = camelWalking
    // this.camelFrighten = camelFrighten
    // this.camelProtagonist = camelProtagonist
    // this.camelCarryWalk = camelCarryWalk
    // this.camelCarryWink = camelCarryWink

    this.addChildAt(camel, 0)
    this.normal()
  }

  removeAllChild(){
    TWEEN.remove(this.winkingTween)
  }

  carryWalking(distance){
    this.camel.playAnimation(R.spines.camel.animations.walking, true)
    let duration = distance * 3

    this._tween = new TWEEN.Tween(this)
      .to({x: this.x + distance}, duration)
      .easing(TWEEN.Easing.Linear.None)
      .onComplete(() => {
        SoundManager.instance.playEffect(R.sounds.level1_donkey)

        this.camel.playAnimation(
          R.spines.camel.animations.frighten,
          false,
          () => {
            this.camel.playAnimation(
              R.spines.camel.animations.protagonist,
              false,
              () => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })

          })
      })
      .start()
  }

  camelWithManWalking(man, distance, onComplete){
    this.camel.playAnimation(R.spines.camel.animations.carryWalk, true)
    let duration = distance * 2

    const currentX = this.x
    this._manTween = new TWEEN.Tween(man)
      .to({x: `+${distance}`}, duration)
      .start()

    this._tween = new TWEEN.Tween(this)
      .to({x: `+${distance}`}, duration)
      .onComplete(() => {
        onComplete()
        this.normal()
      })
      .start()
  }

  normal(){
    this.camel.playAnimation(R.spines.camel.animations.winking, true)
  }

  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
      })
      .on('touchstart', () => {
      })
      .on('mouseout', () => {
      })
      .on('mouseover', () => {
      })
      .on('mouseup', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
      .on('touchend', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')

  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level1/Camel.js